import clone from 'clone'
import http from '@/utils/ajax'
import { TREATY_PARAMETERS_PARAM_INIT_LOADING, TREATY_PARAMETERS_PARAM_INIT_SUCCESS, TREATY_PARAMETERS_PARAM_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  ttyForm: {
    ttyNo: undefined,
    ttyDesc: undefined,
    ttyType: undefined,
    ttYYr: undefined
  },
  miscTtyInfo: {
    riType: undefined,
    ttyRef: undefined,
    uwYr: undefined,
    dispSep: undefined
  }
}

const getters = {

}

const mutations = {
  [TREATY_PARAMETERS_PARAM_INIT_LOADING](state, err) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [TREATY_PARAMETERS_PARAM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [TREATY_PARAMETERS_PARAM_INIT_FAIL](state, err) {
    state.init = 2
    state.initErr = err
    state.menu = {}
  }
}

const actions = {
  async treatyManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.treatyManagement
    commit(TREATY_PARAMETERS_PARAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TREATY_PARAMETERS_PARAM_INIT_SUCCESS, commitResult)
    } catch (err) {
      commit(TREATY_PARAMETERS_PARAM_INIT_FAIL, extractMessages(err))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
